import { mapDTO } from '@twistezo/ts-dto-mapper'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { csManagerFromDTO } from 'features/workspace/mappers/csManager'
import { WorkspaceAlert } from 'features/workspace/types/workspaceAlert'
import { WorkspaceSlice } from '../types'
import { WorkspaceSliceDTO } from './types'

export const workspaceFromDTO = (from: WorkspaceSliceDTO): WorkspaceSlice =>
  mapDTO<WorkspaceSliceDTO, WorkspaceSlice>({ from }).transform(workspace => {
    const { alerts, csManager } = workspace

    return {
      ...workspace,
      alerts: alertsFromDTO<WorkspaceAlert>(alerts),
      csManager: csManager ? csManagerFromDTO(csManager) : undefined,
    }
  })
